import React from "react";
import { Geo } from "../messages";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { DistanceLabel } from "./DistanceLabel";
import { metersToMilesRounded } from "./VisitListComponents";

interface Props {
  origin: Geo;
  destination: Geo;
}

const AvailableVisitDistance = (props: Props) => {
  return (
    <div>
      <DistanceLabel
        distanceRequest={{
          origin: props.origin,
          destination: props.destination,
        }}
        formatter={metersToMilesRounded}
      />
      {" " + translate(STRINGS.MILES_AWAY)}
    </div>
  );
};

export default AvailableVisitDistance;
